import React from 'react';

import homeBg from '../../../images/home-bg.jpg';
import aboutBg from '../../../images/about-bg.jpg';
import skylineBg from '../../../images/skyline.jpg';

/* Slider component */
const Slider = () => {
  console.error(skylineBg + ': this image is too big')
  return (
    <div id="myCarousel" className="carousel slide">
      <ol className="carousel-indicators">
          <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
          <li data-target="#myCarousel" data-slide-to="1"></li>
          <li data-target="#myCarousel" data-slide-to="2"></li>
      </ol>

      <div className="carousel-inner">
          <div className="item active">
              <div className="fill" style={{backgroundImage: `url(${homeBg})`}}></div>
              <div className="carousel-caption">
                  <h2>Trade with BinaryOptions</h2>
              </div>
          </div>
          <div className="item">
              <div className="fill" style={{backgroundImage: `url(${aboutBg})`}}></div>
              <div className="carousel-caption">
                  <h2>Earn Bitcoins with BinaryOptions</h2>
              </div>
          </div>
          <div className="item">
              <div id="skyline" className="fill" style={{backgroundImage: `url(${skylineBg})`}}></div>
              <div className="carousel-caption">
                  <h2>Specialize in Forex & Indices markets with BinaryOptions</h2>
              </div>
          </div>
      </div>

      <a className="left carousel-control" href="#myCarousel" data-slide="prev">
          <span className="icon-prev"></span>
      </a>
      <a className="right carousel-control" href="#myCarousel" data-slide="next">
          <span className="icon-next"></span>
      </a>
    </div>
  )
}

export default Slider


// WEBPACK FOOTER //
// ./src/components/pages/Home/Slider.js